import $ from 'jquery';
import productRecommendationsBase from '../../views/recommendations/productrecommendations';
import { triggerEvent } from '../../vendor/googletagmanager/events';

const productRecommendations = {
    _buildMessage: function(recommendation) {
        return $(
            '<div class="product-recommendation-message">' +
                recommendation.resultText +
                ' <a href="#' +
                this._buildSelector(recommendation) +
                '" class="product-recommendation-more product-recommendation-modal-trigger nobr" title="' +
                this._buildTitle(recommendation) +
                '" data-event-category="' +
                recommendation.eventCategory +
                '" data-event-action="Click" data-event-label="' +
                recommendation.categoryName +
                '">(Learn More)</a></div>'
        );
    },
    _buildSelector: function(recommendation) {
        return recommendation.categoryName.toLowerCase().replace(/\W/gi, '-') + '-' + recommendation.productClassId;
    },
    _buildTitle: function(recommendation) {
        return 'Supplement Wizard: ' + recommendation.categoryName + ' Result';
    },
    _buildModal: function(recommendation, productDetails) {
        return $(
            '<div id="' +
                this._buildSelector(recommendation) +
                '" class="jsHide"><p>' +
                recommendation.justification +
                '</p>' +
                '<div class="product-recommendation-details">' +
                '<div><img src="' +
                productDetails.src +
                '" alt="' +
                productDetails.name +
                '" /></div>' +
                '<div>' +
                '<div class="product-recommendation-details-name">' +
                productDetails.name +
                '</div>' +
                '<div class="product-recommendation-details-reviews searchReviewStars styleReviews" data-bv-show="inline_rating" data-bv-product-id="' +
                recommendation.productClassId +
                '" ></div>' +
                '<div class="product-recommendation-details-price">' +
                productDetails.price +
                '</div>' +
                '</div>' +
                '<div class="button-row wide">'+
                '<a class="secondary purchase button product-recommendations-wishlist" data-size="sm" href="#" data-recommendation-productClassId="' +
                recommendation.productClassId +
                '">Save to Wishlist</a>' +
                '<a class="purchase button" data-size="sm" href="' +
                productDetails.url +
                '">Buy Now</a>' +
                '</div>' +
                '</div>' +
                '<p>Not interested? <a href="#" class="product-recommedation-dismiss" data-recommendation-productClassId="' +
                recommendation.productClassId +
                '" data-event-category="' +
                recommendation.eventCategory +
                '" data-event-action="Dismiss" data-event-label="' +
                recommendation.categoryName +
                '">Click here to hide</a></p>' +
            '<p>Looking for additional results? <a href="/horse-supplement-wizard">Visit the Supplement Wizard</a></p>' +
                '</div>'
        );
    },
    _fireEvent: function(e) {
        if (
            e.currentTarget.dataset.eventCategory &&
            e.currentTarget.dataset.eventAction &&
            e.currentTarget.dataset.eventLabel
        ) {
            triggerEvent(
                e.currentTarget.dataset.eventCategory,
                e.currentTarget.dataset.eventAction,
                e.currentTarget.dataset.eventLabel
            );
        }
    },
    _addEventListeners: function() {
        $('#product-grid').on(
            'click',
            '.product-recommendation-modal-trigger',
            function(e) {
                e.preventDefault();

                this._fireEvent(e);

                smartPak.ui.modal($(e.currentTarget.getAttribute('href'))[0], {
                    title: e.currentTarget.title,
                    modalClass: 'product-recommendation-modal',
                    width: 550,
                    open: this._handleModalOpen.bind(this)
                });
            }.bind(this)
        );
    },
    _handleModalOpen: function(modal) {
        var $modal = $(modal.element);

        $modal.find('svg').removeAttr('style');

        $modal
            .off('click')
            .on(
                'click',
                '.product-recommedation-dismiss',
                function(e) {
                    e.preventDefault();
                    this._fireEvent(e);

                    modal.close();

                    productRecommendationsBase
                        .dismissById(e.currentTarget.dataset.recommendationProductclassid)
                        .done(
                            function() {
                                this._remove(e.currentTarget.dataset.recommendationProductclassid);
                            }.bind(this)
                        );
                }.bind(this)
            )
            .on('click', '.product-recommendations-wishlist', function(e) {
                e.preventDefault();

                $.post(
                    '/product/addtowishlist',
                    'productclassId=' + e.currentTarget.dataset.recommendationProductclassid
                ).done(function() {
                    smartPak.page.redirectToUrl('/wishlist');
                });
            });
    },
    _remove: function(productClassId) {
        var $product = $('#product-grid')
            .find('[data-productClassId="' + productClassId + '"]')
            .closest('.product-recommendations-container');

        if ($product.length) {
            $product
                .removeClass('product-recommendations-container')
                .find('.product-badge')
                .remove()
                .end()
                .find('.product-recommendation-message')
                .remove();
        }
    },
    _addRecommendations: function(recommendations) {
        recommendations.forEach(
            function(recommendation) {
                var $element = $('#product-grid').find('[data-productClassId="' + recommendation.productClassId + '"]');

                recommendation.eventCategory = smartPak.page.isMobile()
                    ? 'Wizard-Mobile-SearchProd'
                    : 'Wizard-Desktop-SearchProd';

                if ($element.length) {
                    this._addRecommendation(recommendation, $element.closest('.product'));
                    triggerEvent(
                        recommendation.eventCategory,
                        'View',
                        recommendation.categoryName
                    );
                }
            }.bind(this)
        );
    },
    _findProductDetails: function($element) {
        return {
            price: $element
                .find('.product-price')
                .text()
                .trim(),
            url: $element
                 .find('a')
                 .attr('href'),
            name: $element
                  .find('.product-name')
                  .text()
                  .trim(),
            src: $element
                .find('a img')
                .attr('src')
                .replace('224', '100')
        };
    },
    _addRecommendation: function(recommendation, $element) {
        $element
            .addClass('product-recommendations-container')
            .prepend('<div class="product-badge product-recommendations-badge">Wizard Result</div>')
            .append(this._buildModal(recommendation, this._findProductDetails($element)))
            .find('.category-review')
            .append(this._buildMessage(recommendation));
    },
    init: function(recommendations) {
        this._addRecommendations(recommendations);
        this._addEventListeners();
    }
};

export default productRecommendations;
